// A small module to hold a reference to the Redux store instance.
// This avoids circular imports when util modules (like socket) need to
// dispatch actions outside React components.

let store = null;

export const setStore = s => {
  store = s;
};

export const getStore = () => store;

export default {
  setStore,
  getStore,
};
